import styles from "../AddPage.module.scss";
import FormField from "components/FormField";
import DropdownMenu from "../components/DropdownMenu";
import DaySelector from "../components/DaySelector";
import { time } from "utils/constants";

export const formHeader = [
  {
    fieldName: "scheduleName",
    labelText: "Schedule Name",
    required: true,
    className: styles.schedulename,
  },
  {
    fieldName: "breaks",
    labelText: "Breaks",
    required: true,
    className: styles.breaks,
  },
  {
    fieldName: "timezone",
    labelText: "Timezone",
    required: true,
    className: styles.timezone,
  },
  {
    fieldName: "forecasting",
    labelText: "Work Time Forecasting",
    required: true,
    className: styles.forecasting,
  },
];

export const formFields = [
  {
    fieldName: "days",
    labelText: "Days",
    required: true,
    className: styles.days,
  },
  {
    fieldName: "start_hours",
    labelText: "Start",
    required: true,
    className: styles.start_hours,
  },
  {
    fieldName: "start_minutes",
    labelText: "",
    required: true,
    className: styles.start_minutes,
  },
  {
    fieldName: "end_hours",
    labelText: "End",
    required: true,
    className: styles.end_hours,
  },
  {
    fieldName: "end_minutes",
    labelText: "",
    required: true,
    className: styles.end_minutes,
  },
  {
    fieldName: "duration",
    labelText: "Duration",
    required: true,
    className: styles.duration,
  },
];

const getData = (field) => {
  const timeVariant = field.fieldName.includes("hours");
  if (timeVariant) {
    return time.hours;
  } else if (!timeVariant) {
    return time.minutes;
  }
};

export const getShiftRow = (
  idRow,
  changeValueOfTime,
  duration,
  timeValue,
  setTime,
  day,
  setSelectedDayOfWeek,
  selectedDayOfWeek,
  daysOptions,
  formErrors = {
    scheduleName: false,
    breaks: false,
    timezone: false,
    forecasting: false,
    days: false,
    time: false,
  },
) => {
  return formFields.map((field, index) => {
    return field.fieldName === "days" ? (
      <DaySelector
        key={index}
        idRow={idRow}
        day={day}
        setSelectedDayOfWeek={setSelectedDayOfWeek}
        selectedDayOfWeek={selectedDayOfWeek}
        daysOptions={daysOptions}
        formErrors={formErrors.days}
      />
    ) : field.fieldName === "duration" ? (
      <FormField key={index} {...field} value={duration || ""} readOnly />
    ) : (
      <DropdownMenu
        key={index}
        {...field}
        data={getData(field)}
        changeValueOfTime={changeValueOfTime}
        idRow={idRow}
        timeValue={timeValue}
        setTime={setTime}
        formErrors={formErrors.time}
      />
    );
  });
};
